import { useEffect, useId, useRef, type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { t } from '../../i18n';

// Fenster von unten (am Desktop mittig) wie in der Demo. Wird direkt in .mapp gezeichnet, damit es über
// Kopfzeile und Seitenleiste liegt.
// Esc und Klick daneben schließen; der Rest der Seite ist solange nicht bedienbar.
export function Sheet({ title, onClose, children }: { title: ReactNode; onClose(): void; children: ReactNode }) {
  const id = useId();
  const ref = useRef<HTMLDivElement>(null);
  const close = useRef(onClose);
  close.current = onClose;

  useEffect(() => {
    const opener = document.activeElement as HTMLElement | null;
    const app = document.querySelector<HTMLElement>('.mapp > .app');
    app?.setAttribute('inert', '');
    const overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    ref.current?.querySelector<HTMLElement>('.x')?.focus();
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        close.current();
      }
    };
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('keydown', onKey);
      app?.removeAttribute('inert');
      document.body.style.overflow = overflow;
      if (opener?.isConnected) opener.focus();
    };
  }, []);

  const host = document.querySelector('.mapp') ?? document.body;
  return createPortal(
    <div
      className="sheet-bg"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="sheet" role="dialog" aria-modal="true" aria-labelledby={id} ref={ref}>
        <div className="sheet-top">
          <b id={id}>{title}</b>
          <button type="button" className="x" aria-label={t('Schließen')} onClick={onClose}>
            ×
          </button>
        </div>
        {children}
      </div>
    </div>,
    host,
  );
}
